<template>
    <div v-show="isFullscreenVisible" ref="buttonFS" class="full-screen-button a-vg-icon full-screen-icon" @click.stop='toggleFullScreen'>
        <image-svg :imageName="loadImage()"/>
    </div>
</template>
<script>
import ImageSVG from '@/components/common/ImageSVG.vue'
import { store } from '@/store/store.js'
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'

export default {
  components: {
    'image-svg': ImageSVG
  },
  data () {
    return {
      fullScreenActive: false
    }
  },
  props: {
    marginBottom: String
  },
  watch: {
    marginBottom: function (newValue, oldValue) {
      this.$refs.buttonFS.style.marginBottom = newValue
    }
  },
  computed: {
    isFullscreenVisible () {
      return store.isFullscreenAllowed()
    }
  },
  created: function () {
    eventBus.$on(EventConstants.CHANGE_FULLSCREEN_VARIABLE, this.setFSVariable)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.CHANGE_FULLSCREEN_VARIABLE, this.setFSVariable)
  },
  methods: {
    setFSVariable (data) {
      this.fullScreenActive = data
    },
    toggleFullScreen () {
      this.$emit('toggleFullScreen')
      this.fullScreenActive = !this.fullScreenActive
    },
    loadImage () {
      return this.fullScreenActive ? 'fs-off' : 'fs-on'
    }
  }
}
</script>
